var ajaxShippingLoading = false;
var btnCart1 = document.getElementById('cartCheckout');
var btnCart2 = document.getElementById('cartCheckoutSticky');
var btnCart3 = document.getElementById('continue_button');
var zipcode = localStorage.getItem("zipcode");

if (Shopify && Shopify.Checkout && Shopify.Checkout.step === 'shipping_method' && typeof validateZipcodes == 'function') {
  validateZipcodes();
}
const toggleCheckout = (disabled) =>{
  if(typeof(btnCart1) != 'undefined' && btnCart1 != null){
    btnCart1.disabled = disabled;
  }
  if(typeof(btnCart2) != 'undefined' && btnCart2 != null){
    btnCart2.disabled = disabled;
  }
  if(typeof(btnCart3) != 'undefined' && btnCart3 != null){
    btnCart3.disabled = disabled;
  }
}
const isRestrictedZip = () => !zipcode ? false : restricted_zip_codes.includes(zipcode);

async function checkShippingMsg(){
          
  ajaxShippingLoading = true;
  const cartShippingItemTpl = $('#cart-shipping-item-tpl').html();
  const cartShippingCta = $('#cart-shipping-cta');  
  const cartShippingAlert = $('#cart-shipping-alert');
  if(typeof JQ=='undefined'){
    JQ = $;
  }
  const modalCartShipping = JQ('#modal-cart-shipping');
  let itemsHtml=[];
  let idsVariants =[];
  let itemsNotAvailable =[];
  cartShippingCta.on('click',()=>{
    const continueShopping = idsVariants.length == itemsNotAvailable.length;
    let itemstoRemove = {};
    itemsNotAvailable.forEach(({variant_id}) => {
      itemstoRemove[variant_id] = 0;
    });
    $.post('/cart/update.js', {
      updates: itemstoRemove
    },()=>{},'json')
    .always(function() {
      if(continueShopping) {
        window.location.href = "/collections/all";
      } else {
        window.location.reload();
      }
    });
  });
   
  const  data = await $.getJSON('/cart.js');
  const {items, item_count: totalRestrictedItems} = data;
  idsVariants = items.map((i)=>i.variant_id);

  // /cart input
  if($('#asm-force-zip').length && $('#asm-force-zip').val() != '') {
    zipcode = $('#asm-force-zip').val();
  }
  // /checkout input
  if($('#checkout_shipping_address_zip').length && $('#checkout_shipping_address_zip').val() != '') {
    zipcode = $('#checkout_shipping_address_zip').val();
  }
  zipcode = zipcode? zipcode.toString() : '';
  if(zipcode.length == 0) {
    let resExpired = await getZipByIpExpired(true);
    zipcode = resExpired.zip;
  }
  zipcode = zipcode ? zipcode.toString() : '';
  itemsNotAvailable =[];
  zipcode = zipcode.length > 0 ? zipcode: 1;

  var isRestricted = false;
  var notAvailables = [];
  
  if(isRestrictedZip()) {
    toggleCheckout(true);
    var {isRestricted, notAvailables} = await $.post(baseWorker, JSON.stringify({
      storefront_code,
      type: 'check_restricted_cart',
      zip: zipcode,
      items: idsVariants
    }));
    itemsNotAvailable = items.filter(i=>notAvailables.includes(i.variant_id))

    itemsNotAvailable.forEach(item => {
      itemsHtml.push(
          cartShippingItemTpl
            .replace(/%title%/ig, item.product_title)
            .replace(/%description%/ig, item.options_with_values.map(i=>i.value).join('/'))
            .replace('%img%', item.image)
        );
    });
    if(itemsHtml.length) {
      const singular = itemsHtml.length == 1;
      const continueShopping = itemsHtml.length == items.length;
      const txtAlert = `${singular ? 'An item' : 'Items'} in your cart ${singular ? 'is' : 'are'}  
      <b>not available for shipping</b> in your location. 
      Please remove the item${singular?'':'s'}${continueShopping ?'':'  to proceed'}.`;
      const txtButton = `remove item${singular ? '' : 's'}${continueShopping ?' & continue shopping':''}`;
      cartShippingAlert.html(txtAlert);
      cartShippingCta.html(txtButton);

      $( "#cart-shipping-items" ).html( itemsHtml.join('') );
      // keeps blocked becuase there is products to remove
    } else {
      toggleCheckout(false);
    }
  }
  ajaxShippingLoading = false;
  if(isRestricted && totalRestrictedItems >= 10){
    $('#shipping-cart-alert').show();
    $('#asm-shipping-methods-list').hide();
    $('#section__content-msg-cart-shipping').show();
    $('#section__content-msg-cart-shipping').prev().hide();
    if (Shopify && Shopify.Checkout && Shopify.Checkout.step === 'shipping_method') {
      $('#continue_button').hide();
    }
  }else{
    $('#shipping-cart-alert').hide();
    $('#section__content-msg-cart-shipping').hide();
    $('#section__content-msg-cart-shipping').prev().show();
    if (Shopify && Shopify.Checkout && Shopify.Checkout.step === 'shipping_method') {
      $('#continue_button').show();
    }
  }

  if(isRestricted && notAvailables.length) {
    if (typeof modalCartShipping.modal === 'function') {
      modalCartShipping.modal('show');
    } else {
      JQ('body').addClass('modal-open');
      modalCartShipping.addClass("show");
    }
  }
}
if(isRestrictedZip()) {
  toggleCheckout(true);
}

window.onload = function() {
  if(!ajaxShippingLoading){
    checkShippingMsg();
  }
};
